import { render } from "./AboutHelpYourBusinessCard.vue?vue&type=template&id=5b059722&scoped=true"
import script from "./AboutHelpYourBusinessCard.vue?vue&type=script&lang=js"
export * from "./AboutHelpYourBusinessCard.vue?vue&type=script&lang=js"

import "./AboutHelpYourBusinessCard.vue?vue&type=style&index=0&id=5b059722&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b059722"]])

export default __exports__